module.exports = __webpack_public_path__ + "img/banner_1.13cc8d32.jpg";